module.exports = __webpack_public_path__ + "img/cjfwU8.a73b8a74.png";